import { render, staticRenderFns } from "./taskInfo.vue?vue&type=template&id=76edcc50&scoped=true&"
import script from "./taskInfo.vue?vue&type=script&lang=js&"
export * from "./taskInfo.vue?vue&type=script&lang=js&"
import style0 from "./taskInfo.vue?vue&type=style&index=0&id=76edcc50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76edcc50",
  null
  
)

export default component.exports